export enum QuoteStatus {
    Draft = 'draft',
    Finalized = 'finalized',
    Validated = 'validated',
    Declined = 'declined',
    Closed = 'closed',
}